import { fmtKwp, fmtMoney } from "@/lib/apolloCalc";

// Numero WhatsApp aziendale (formato internazionale senza +)
export const WHATSAPP_NUMBER = "41789062764";

// Generazione dinamica del link wa.me con messaggio URL-encoded
export const buildWhatsAppLink = (text) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const GENERIC_WA_MESSAGE =
  "Ciao Apollo.AI, vorrei informazioni sulla piattaforma per il mio business solare";

// Messaggio precompilato con i valori reali calcolati da Apollo.AI
export const buildSimulationMessage = (r) =>
  `Ciao, ho usato Apollo.AI sul vostro sito. La mia simulazione: ${r.address} – ${r.buildingType} – ${r.panels} pannelli – ${fmtKwp(r.kwp)} kWp – Risparmio stimato ${fmtMoney(r.savings, r.currency)}/anno – Fattibilità ${r.feasibility}%. Vorrei ricevere maggiori informazioni gratuite.`;

export const openWhatsApp = (text) => window.open(buildWhatsAppLink(text), "_blank", "noopener,noreferrer");
